export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="16"
    width="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.743 13.127L10.716.977A1.985 1.985 0 009 0a1.996 1.996 0 00-1.715.978L.258 13.128a1.875 1.875 0 000 1.897A1.952 1.952 0 001.974 16h14.053a1.964 1.964 0 001.714-.975 1.875 1.875 0 00.002-1.898zM8.358 6.4A.639.639 0 019 5.76a.644.644 0 01.643.64v3.2a.639.639 0 01-.643.64.644.644 0 01-.642-.64V6.4zM9 13.44a.967.967 0 01-.89-.593.956.956 0 01.702-1.309.968.968 0 01.99.409.957.957 0 01-.12 1.212.966.966 0 01-.682.28z"
      fill="#FFA800"
    />
  </svg>
);
